import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, CircularProgress, Button } from '@mui/material';
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import projectService from '../../services/projectService';
import QuestionCard from '../shared/QuestionCard';

const useStyle = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    marginTop: '2rem',
  },
  marginBottom: {
    marginBottom: '1rem',
  },
}));

const Questions = ({ workId }) => {
  const classes = useStyle();
  const [showAll, setShowAll] = useState(true);
  const queryClient = useQueryClient();
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: ['getQuestions', workId],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        sort_key: 'created_at',
        sort_direction: 'desc',
        per_page: 3,
        page: pageParam,
      };
      const response = await projectService.getQuestions(workId, params);
      return {
        data: response.questions ?? [],
        meta: response.meta ?? { nextPage: null },
      };
    },
    getNextPageParam: (lastPage) => lastPage.meta?.nextPage ?? undefined,
    enabled: !!workId,
  });
  const allPages = data?.pages ?? [];
  const allQuestions = showAll ? allPages.flatMap((page) => page.data) : (allPages[0]?.data ?? []);

  const handleShowLess = () => {
    setShowAll(false);
    queryClient.resetQueries(['getQuestions', workId]);
  };
  if (isLoading) {
    return (
      <div className={classes.container}>
        <CircularProgress />
      </div>
    );
  }
  return (
    <div style={{ width: '100%' }}>
      {allQuestions.length > 0 ? (
        <div>
          {allQuestions.map((question) => (
            <QuestionCard key={question.id} question={question} workId={workId} />
          ))}
          {hasNextPage && showAll && (
            <div className={classes.container}>
              <Button
                variant="contained"
                onClick={() => fetchNextPage()}
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? 'Loading...' : 'Load more'}
              </Button>
            </div>
          )}
          {showAll && allQuestions.length > 3 && (
            <div className={classes.container}>
              <Button variant="outlined" onClick={handleShowLess}>
                Show less
              </Button>
            </div>
          )}
        </div>
      ) : (
        <Typography variant="h6" className={classes.marginBottom}>
          No questions yet
        </Typography>
      )}
    </div>
  );
};

export default Questions;
